export const ADD_LANGUAGES_SECTION = "ADD_LANGUAGES_SECTION";
export const ADD_PLAN_SECTION = "ADD_PLAN_SECTION";
export const ADD_UPDATE_LANGUAGES_SECTION = "ADD_UPDATE_LANGUAGES_SECTION";
export const ADD_EXTRA_CHARACTERS_SECTION = "ADD_EXTRA_CHARACTERS_SECTION";